const browserEnv = typeof window !== 'undefined' && window.__JJUMA_ENV__ ? window.__JJUMA_ENV__ : {};
const legacyEnv = typeof process !== 'undefined' && process.env ? process.env : {};

function normalizeUrl(value) {
  return String(value || '').trim().replace(/\/$/, '');
}

function readEnv(...keys) {
  for (const key of keys) {
    const value = browserEnv[key] || legacyEnv[key];
    if (value) return value;
  }
  return '';
}

export function getBackendUrl() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const localDefault = hostname === 'localhost' || hostname === '127.0.0.1' ? 'http://localhost:8000' : 'https://api.jjuma.com';
  const raw =
    readEnv(
      'VITE_API_BASE_URL',
      'VITE_API_URL',
      'VITE_BACKEND_URL',
      'REACT_APP_BACKEND_URL',
      'REACT_APP_API_BASE_URL',
      'REACT_APP_API_URL',
    ) || localDefault;

  return normalizeUrl(raw || localDefault);
}
